import { render, staticRenderFns } from "./CancellationApplications.vue?vue&type=template&id=63c22389&scoped=true&"
import script from "./CancellationApplications.vue?vue&type=script&lang=js&"
export * from "./CancellationApplications.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=63c22389&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c22389",
  null
  
)

export default component.exports